module.exports = function() {
  return new Worker(__webpack_public_path__ + "645d26585b9bddb61e09.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/build/pdf.worker.js
// module id = 1368
// module chunks = 2